import { Component } from '@angular/core';

@Component({
    selector: 'teacher',
    templateUrl: './teacher.template.html',
    styleUrls: ['./teacher.style.scss'],
    standalone: false
})

export class Teacher {

  constructor () {}

  ngOnInit() {  
  }
}